export const appointmentRoutes = [
  {
      name: "appointment-detail",
      path: "/ward/:wardId/appointment/:appointmentId?",
      component: () => import("@/app/appointments/Appointment"),
      props: true
  },
  {
    name: "appointment-list",
    path: "/ward/:wardId/appointments",
    component: () => import("@/app/appointments/AppointmentList"),
    props: true
  }
]
